export const MY_REQUESTS_URL = 'https://meus-pedidos.olx.com.br';
export const URL_SITE_OLX = 'https://www.olx.com.br/';
export const URL_CONTACT_US = 'https://ajuda.olx.com.br/fale-conosco';
export const URL_HELP_CENTER = 'https://ajuda.olx.com.br/s';
